// Shared centered loading spinner for every julkisivu v2 table view
// (Poränäyte/Peitepaksuus/Vetolujuus/Ohuthie/Kloridipitoisuus/Rappausnäyte).
// The parent must be (or become) position:relative for `inset: 0` to center
// over just that table, not the whole page.
export default function TableLoadingOverlay({ show }) {
  if (!show) return null;
  return (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 5,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(255,255,255,0.7)', minHeight: 80,
    }}>
      <span className="spinner-border" role="status"
        style={{ color: '#04aa00', width: '2.5rem', height: '2.5rem', borderWidth: '0.3em' }} />
    </div>
  );
}
